@switch (column.cellType) {
        @case (_TableCellType.button) {
            @for (button of getDirectButtons(); track button.id) {
                <button pButton type="button" class="p-button-text" [icon]="button.icon" [pTooltip]="button.description" (click)="buttonClick($event, button)"></button>
            }
            @if (getBurgerMenuButtons().length > 0) {
                <button pButton type="button" class="p-button-text" icon="fas fa-bars" pTooltip="Aktionen" (click)="burgerMenuClick($event)"></button>
            }
        }
        @case (_TableCellType.color) {
            <span class="badge m-1" [style.background]="_Utils.toColorHexString(params.value)" [class.no-wrap-cell]=false>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        }
        @case (_TableCellType.link) {
            <span
                ><a href="#" (click)="buttonClick($event, null)">{{ params.value }}</a></span
            >
        }
        @default {
            @if (getKeepHtml()) {
                <span
                    #value
                    class="content"
                    [tp]="toolTip?.getComponentOnHover()"
                    [tpData]="toolTip?.data"
                    [tpDelay]="[500, 0]"
                    tpPlacement="auto"
                    tpBoundary="viewport"
                    tpVariation="tooltip"
                    [innerHTML]="displayValue"
                ></span>
            } @else {
                <span
                    #value
                    class="content"
                    [tp]="toolTip?.getComponentOnHover()"
                    [tpData]="toolTip?.data"
                    [tpDelay]="[500, 0]"
                    tpPlacement="auto"
                    tpBoundary="viewport"
                    tpVariation="tooltip"
                    >{{ displayValue }}</span
                >
            }
            @if (getVisibleAddOnButtons().length > 0) {
                <div class="cell-add-on-buttons">
                    @for (button of getVisibleAddOnButtons(); track button.id) {
                        <button pButton type="button" class="cell-add-on-button p-button-text" [icon]="button.icon" [pTooltip]="button.description" (click)="addOnButtonClick($event, button)"></button>
                    }
                </div>
            }
        }
    }
    @if (mouseInside && !params.colDef.context.table.actionButtonsOnRightClick && (params.colDef.context.table.actionButtons || buttonActions?.length > 0)) {
        <div class="action-buttons-container">
            @if (tableCell?.actionsAsContextMenu) {
                <button pButton type="button" class="action-button p-button-text" icon="fas fa-bars" (click)="actionContextMenuButtonClick($event)"></button>
            } @else {
                @for (action of buttonActions; track action) {
                    <button
                        pButton
                        type="button"
                        class="action-button p-button-text"
                        [pTooltip]="action.getCaption()"
                        [icon]="action.getIcon()"
                        (click)="actionButtonClick($event, action)"
                    ></button>
                }
            }
            @if (params.colDef.context.table.actionButtons) {
                <button pButton type="button" class="action-button action-context-button p-button-text" icon="fas fa-bars" (click)="actionContextButtonClick($event)"></button>
            }
        </div>
}
